import React from 'react';
import { Home, Navigation } from 'lucide-react';
import { linkMapaDomicilio, textoDireccionDomicilio } from '../../utils/domicilio';

// 🏠 Dirección de un turno a domicilio + botón "Cómo llegar" (abre Google
// Maps o la app de mapas del celular — es un link común, no usa la API).
// Solo se dibuja si la reserva tiene booking.domicilio.
const DomicilioInfo = ({ booking, isDarkMode, className = '' }) => {
  const dom = booking?.domicilio;
  if (!dom) return null;
  const link = dom.mapsUrl || linkMapaDomicilio(dom);
  const soft = isDarkMode ? 'text-white/60' : 'text-gray-600';

  return (
    <div className={`flex items-start justify-between gap-3 rounded-2xl px-3.5 py-3 ${isDarkMode ? 'bg-amber-500/[0.12]' : 'bg-amber-500/10'} ${className}`}>
      <div className="flex items-start gap-2.5 min-w-0">
        <Home size={16} className="text-amber-500 shrink-0 mt-0.5" />
        <div className="min-w-0">
          <p className="text-[13px] font-semibold text-amber-500">A domicilio</p>
          <p className={`text-[14px] font-medium leading-snug break-words ${isDarkMode ? 'text-gray-50' : 'text-gray-900'}`}>{textoDireccionDomicilio(dom)}</p>
          {dom.referencia && <p className={`text-[13px] leading-snug mt-0.5 break-words ${soft}`}>{dom.referencia}</p>}
        </div>
      </div>
      {link && (
        <a href={link} target="_blank" rel="noopener noreferrer"
          className="shrink-0 inline-flex items-center gap-1.5 h-9 px-3 rounded-xl text-[13px] font-semibold bg-amber-500 text-black hover:bg-amber-400 transition-colors active:scale-95">
          <Navigation size={13} /> Cómo llegar
        </a>
      )}
    </div>
  );
};

export default DomicilioInfo;
